import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNextIcon from './svgs/NextIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var nextIcon = (props => useIcon(SvgNextIcon, SvgNextIcon, props));

export { nextIcon as default };
